var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.333 325.001H1191.67M541.666 595.834V866.667M758.333 595.834V866.667M216.666 325.001H1083.33L997.75 1095.25C994.816 1121.76 982.207 1146.25 962.338 1164.04C942.469 1181.83 916.736 1191.67 890.066 1191.67H409.933C383.263 1191.67 357.53 1181.83 337.661 1164.04C317.792 1146.25 305.183 1121.76 302.25 1095.25L216.666 325.001ZM397.854 170.463C406.615 151.882 420.48 136.175 437.829 125.175C455.179 114.175 475.298 108.334 495.841 108.334H804.158C824.71 108.323 844.842 114.159 862.202 125.16C879.562 136.162 893.434 151.874 902.2 170.463L975 325.001H325L397.854 170.463V170.463Z",
    className: "svgStroke",
    strokeWidth: 60,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsTrashCan);
export default __webpack_public_path__ + "static/media/akar-icons_trash-can.bde24140d39e1a149d9ef4df04745c30.svg";
export { ForwardRef as ReactComponent };